import { createAsyncThunk } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { GetApiCall, ApiCall } from '../../helper/axios';

export const getProductAsync = createAsyncThunk('fetch/getProduct', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const { after, before, query, limit } = param.payload;
    let url = `/products?shop=${config_variable.shop_name}`;
    if (after) {
        url += `&after=${after}`;
    }
    if (before) {
        url += `&before=${before}`;
    }
    if (query) {
        url += `&query=${query}`;
    }
    if (limit) {
        url += `&limit=${limit}`;
    }
    const res = await GetApiCall('GET', url, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getProductVariantAsync = createAsyncThunk('fetch/getProductVariant', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const { after, before, limit } = param.payload;
    let url = `/product-variants?shop=${config_variable.shop_name}&id=${param.id}`;
    if (after) {
        url += `&after=${after}`;
    }
    if (before) {
        url += `&before=${before}`;
    }
    if (limit) {
        url += `&limit=${limit}`;
    }
    const res = await GetApiCall('GET', url, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const importMetafieldsIntoProductAsync = createAsyncThunk('import/metafields', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    let url = `/import-metafields?shop=${config_variable.shop_name}`;
    const res = await ApiCall('POST', url, param.payload, { authentication: store_data?.token });
    if (res.data.success && res.status === 200) {
        param.callback(res.data.success, res.data.message);
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getCollectionAsync = createAsyncThunk('fetch/getCollection', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const { after, before, query, limit } = param.payload;
    let url = `/collections?shop=${config_variable.shop_name}`;
    if (after) {
        url += `&after=${after}`;
    }
    if (before) {
        url += `&before=${before}`;
    }
    if (query) {
        url += `&query=${query}`;
    }
    if (limit) {
        url += `&limit=${limit}`;
    }
    const res = await GetApiCall('GET', url, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});